import React from 'react';
import imgLogo from '../../../assets/img/logo.png';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { connect } from 'react-redux';
import Card from '../../shared/components/Card';
import CardBody from '../../shared/components/CardBody';
import { bindActionCreators } from 'redux';
import * as authActions from '../actions/authActions';
import Row from '../../shared/components/Row';
import { isEmailValid } from '../../shared/utils/StringUtils';
import { PsRoutes } from '../../shared/routing/Routes';
import { Link } from 'react-router-dom';

class RememberPasswordScreen extends React.Component {

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        document.body.classList.add('login-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('login-page');
    }

    onSubmit(event) {
        event.preventDefault();
        this.props.authActions.rememberPassword(this.props.email);
    }

    render() {
        return (
            <div className="login-box">
                <div className="logo">
                    <img src={imgLogo} alt="Pavasal" className="img-responsive center-block m-b-15"/>
                    <small>{I18nUtils.tr('TR_BIENVENIDO_AL_SISTEMA_DE_GESTION_DE_DOCUMENTACION')}</small>
                </div>
                <Card loading={this.props.loadingRememberPassword}>
                    <CardBody>
                        <form onSubmit={this.onSubmit}>
                            <div className="msg">
                                {I18nUtils.tr('TR_REMEMBER_PASSWORD_DESCRIPTION')}
                            </div>
                            <div className="input-group">
                <span className="input-group-addon">
                    <i className="material-icons">email</i>
                </span>
                                <div className="form-line">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={I18nUtils.tr('TR_EMAIL')}
                                        required
                                        autoFocus
                                        value={this.props.email}
                                        onChange={(event) => {
                                            this.props.authActions.changeEmail(event.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <button
                                className="btn btn-block btn-lg bg-blue-grey waves-effect"
                                type="submit"
                                disabled={!this.props.btnEnabled}
                            >{I18nUtils.tr('TR_RESTAURAR_CONTRASENA')}</button>

                            <Row>
                                <div className="col-md-12">
                                    <p className={'text-error'}>{this.props.errorRememberPassword}</p>
                                </div>
                            </Row>

                            <div className="row m-t-20 m-b--5 align-center">
                                <Link to={PsRoutes.HOME}>
                                    {I18nUtils.tr('TR_LOGIN')}
                                </Link>
                            </div>
                        </form>
                    </CardBody>
                </Card>
            </div>
        );
    }

}

const mapStateToProps = state => {
    const btnEnabled = state.auth.email && isEmailValid(state.auth.email);
    return ( {
        loadingRememberPassword: state.auth.loadingRememberPassword,
        email: state.auth.email,
        errorRememberPassword: state.auth.errorRememberPassword,
        btnEnabled,
    } );
};

const mapDispatchToProps = dispatch => ( {
    authActions: bindActionCreators(authActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(RememberPasswordScreen);



// WEBPACK FOOTER //
// ./src/app/login/screens/RememberPasswordScreen.js